export const DASHBOARD_ROUTING = [
    {
        path: '/dashboard',
        name: 'dashboard',
        meta: {
            auth: true,
            breadcrumb: [
                { name: 'Tìm sản phẩm', pathName: 'dashboard', icon: 'fa fa-search' },
            ]
        },
        component: () => import('./Dashboard.vue'),
        redirect: { name: 'dashboard-index' },
        children: [
            { 
                path: '/product-search.html',
                name: 'dashboard-index',
                component: () => import('./components/MainDashboard.vue')
            },
            { 
                path: '/detail-product.html',
                name: 'detail-product-index',
                component: () => import('./components/DetailProduct.vue')
            }
        ]
    }
];